import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';




function ReviemParametres({ email }) {
    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL


    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');


    let LanguageSelected = Cookies.get('LanguageSelected');

    const [parametresModal, setParametresModal] = useState(false)
    const [isFetching, setisFetching] = useState(false)
    const [ParametreInfo, setParametreInfo] = useState('')

    const [ParametreContent, setParametreContent] = useState([])
    const [confirmCodeModal, setconfirmCodeModal] = useState(false)
    const [VerificationCode, setVerificationCode] = useState('')
    const hashedUserId = sha256((String(userId)));
    const [secondEmail, setSecondEmail] = useState('')



    const [Done, setDone] = useState(false)
    const [InputsErrors, setInputsErrors] = useState([])
    const [ModifyEmail, setModifyEmail] = useState(false)
    const [emailCodeModal, setEmailCodeModal] = useState(false)


    const [EntrepriseParametre, setEntrepriseParametre] = useState(false)
    const [EntrepriseParametreData, setEntrepriseParametreData] = useState([])
    const [EntrepriseExists, setEntrepriseExists] = useState(false)



    useEffect(() => {
        getParametres()
    }, [Done])


    const getParametres = () => {
        fetch(`${apiUrl}/getParametresreview`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: userId })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success && result.entreprise) {
                    setEntrepriseParametreData(result.data)
                    setEntrepriseExists(true)
                }
                else if (result.success && !result.entreprise) {
                    setParametreContent(result.data)
                    setValidated(result.validated)

                }
            })
    }
    const deleteParametres = async (id) => {
        fetch(`${apiUrl}/deleteParametresreview`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ parametre_id: id })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                }
            })
    }
    const addParametres = async (e) => {
        setisFetching(true);
        e.preventDefault()
        fetch(`${apiUrl}/addParametresreview`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ parametre: ParametreInfo, user_id: userId })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setParametreInfo('')
                    setDone(!Done)
                    setInputsErrors([])
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });

                }
                else {
                    setInputsErrors(result.errors)
                    toast.error(result.errors.parametre[0], {
                        position: toast.POSITION.CENTER
                    });
                }
            })
            .finally(() => {
                setisFetching(false);
            });
    };

    const sendVerificationCode = async (id) => {
        setisFetching(true);
        fetch(`${apiUrl}/sendVerificationCode`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: hashedUserId, secondEmail: secondEmail })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    setEmailCodeModal(true)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                    setisFetching(false);

                }
                else {
                    toast.error('error sending code', {
                        position: toast.POSITION.CENTER
                    });
                    setisFetching(false);

                }
            })
    }

    const [Validated, setValidated] = useState(false)


    const verifyEmail = async () => {
        setisFetching(true);

        fetch(`${apiUrl}/verifyEmail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: hashedUserId, verification_code: VerificationCode })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    setEmailCodeModal(false)
                    setModifyEmail(false)
                    setVerificationCode(null)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                    setisFetching(false);

                } else {
                    toast.error(result.message, {
                        position: toast.POSITION.CENTER
                    });
                    setisFetching(false);

                }

            })
    }







    return (
        <div>
            {EntrepriseExists ?
                <button onClick={() => { setEntrepriseParametre(true) }} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                    </svg>

                    {t("Add reveiw parametres")}

                </button>
                :
                <button onClick={() => { Validated ? setParametresModal(true) : setModifyEmail(true) }} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                    </svg>

                    {t("Add reveiw parametres")}

                </button>
            }




            {EntrepriseParametre &&
                <div className="minscreen h-screen overflow-auto animated fadeIn faster  w-full fixed  left-0 top-0 flex justify-center items-start inset-0 z-50 forms-info ">
                    <div className={`${LanguageSelected == 'ar' ? 'absolute top-0 left-0 m-2' : 'absolute top-0 right-0 m-2'}`}>
                        <a className='w-6 h-6' onClick={() => { setEntrepriseParametre(false) }} >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                            </svg>
                        </a>
                    </div>

                    <div className='grid place-items-center w-full gap-3 px-3'>
                        <div className=" settingswidth p-4 grid place-items-start gap-3 mt-5">
                            <div className="flex flex-col items-left justify-start ">
                                <p className="text-2xl text-gold font-bold">{t("Add Reveiw Parametres")} </p>
                            </div>
                        </div>
                        <div className='grid place-items-center w-full gap-3 px-3'>


                            {EntrepriseParametreData.length > 0 ?
                                EntrepriseParametreData.map((item, index) => {
                                    return (
                                        <div type="submit" key={index} className=" w-full flex justify-between items-center  p-3 py-2 px-4  border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                                            <div className='flex justify-start items-center gap-2'>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className='w-6 h-6'>
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                                </svg>
                                                {item.value}
                                            </div>

                                        </div>
                                    )
                                })

                                :
                                <div>
                                    <h2 className="text-2xl text-about mb-6">{t("Il n'y a aucun critere.")}</h2>
                                </div>}

                        </div>

                    </div>




                </div>


            }



            {parametresModal &&

                <div>


                    {Validated &&
                        <div className="minscreen h-screen overflow-auto animated fadeIn faster  w-full fixed  left-0 top-0 flex justify-center items-start inset-0 z-50 forms-info ">
                            <div className={`${LanguageSelected == 'ar' ? 'absolute top-0 left-0 m-2' : 'absolute top-0 right-0 m-2'}`}>
                                <a className='w-6 h-6' onClick={() => { setParametresModal(false) }} >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                    </svg>
                                </a>
                            </div>


                            <div className=" settingswidth p-4 grid place-items-start gap-3 mt-5">
                                <div className="flex flex-col items-left justify-start ">
                                    <p className="text-2xl text-gold font-bold">{t("Add Reveiw Parametres")} </p>
                                </div>


                                <div className='flex justify-center items-center w-full gap-3 mt-4'>
                                    <div className=" w-4/5">
                                        <input onChange={(e) => setParametreInfo(e.target.value)} value={ParametreInfo} type="text" id="parametre" name="parametre" className="appearance-none block placeholder-sm h-14 w-full px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Parametre")} required />
                                        {/* <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('parametre') && InputsErrors.parametre}</span></p> */}

                                    </div>



                                    <button onClick={(e) => { addParametres(e) }} type="submit" className={`w-1/5  btn-edit`}>
                                        {isFetching ?
                                            (<svg class="w-6 h-6 text-white animate-spin" viewBox="0 0 64 64" fill="none"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                <path
                                                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path
                                                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                </path>
                                            </svg>)
                                            : (
                                                t('Add')
                                            )
                                        }

                                    </button>


                                </div>


                                <div className='grid place-items-center w-full gap-3'>

                                    {ParametreContent &&
                                        ParametreContent.map((item, index) => {
                                            return (
                                                <div type="submit" key={index} className=" w-full flex justify-between items-center  p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                                                    <div className='flex justify-start items-center gap-2'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className='w-6 h-6'>
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                                        </svg>
                                                        {item.name}
                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        {/* <a onCli>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                        </svg>
                                                    </a> */}
                                                        <a onClick={() => deleteParametres(item.id)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }


                                    <button onClick={(e) => { setModifyEmail(e) }} type="submit" className={`w-full mt-3  btn-edit`}>
                                        {t('Modify email')}
                                    </button>





                                </div>


                            </div>
                        </div>
                    }


                </div>


            }

            {ModifyEmail &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl  div-sections">
                        <div className={`${LanguageSelected == 'ar' ? 'absolute -top-2 -left-2 p-4 ' : 'absolute -top-2 -right-2 p-4'}`} >
                            <a className='w-7 h-7' onClick={() => { setModifyEmail(false) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full settingswidth ">
                            <div className={`${LanguageSelected == 'ar' ? 'pl-6 ' : 'pr-6'}`} >
                                <div className="flex  items-center justify-start ">
                                    <p className="text-2xl text-gold px-3 py-2 font-bold">{t("Email Validation")}</p>
                                </div>
                            </div>
                            <div>
                                <div className='grid place-items-center w-full py-4 gap-4 px-4'>

                                    <div className=" w-full">
                                        <input onChange={(e) => setSecondEmail(e.target.value)} value={secondEmail} type="text" id="email" name="email" className="appearance-none block placeholder-sm h-14 w-full px-3 py-2 border-none sections rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Email Adress")} required />
                                        {/* <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('parametre') && InputsErrors.parametre}</span></p> */}

                                    </div>
                                    <button onClick={(e) => sendVerificationCode()} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                                        {isFetching ?
                                            (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                <path
                                                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path
                                                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                </path>
                                            </svg>)
                                            : (
                                                t('Confirm')
                                            )
                                        }

                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }
            {emailCodeModal &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl  div-sections">
                        <div className={`${LanguageSelected == 'ar' ? 'absolute -top-2 -left-2 p-4 ' : 'absolute -top-2 -right-2 p-4'}`} >
                            <a className='w-7 h-7' onClick={() => { setEmailCodeModal(false) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full settingswidth ">
                            <div className={`${LanguageSelected == 'ar' ? 'pl-6 ' : 'pr-6'}`} >
                                <div className="flex  items-center justify-start ">
                                    <p className="text-2xl text-gold px-3 py-2 font-bold">{t("Email Validation")}</p>
                                </div>
                            </div>
                            <div>
                                <div className='grid place-items-center w-full py-4 gap-4 px-4'>

                                    <div className=" w-full">
                                        <input onChange={(e) => setVerificationCode(e.target.value)} value={VerificationCode} type="number" id="code" name="code" className="appearance-none block placeholder-sm h-14 w-full px-3 py-2 sections border-none rounded placeholder-gray-111 text-black    sm:text-sm" placeholder={t("Verification code")} required />
                                        {/* <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('parametre') && InputsErrors.parametre}</span></p> */}

                                    </div>
                                    <button onClick={(e) => verifyEmail()} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                                        {isFetching ?
                                            (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                <path
                                                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path
                                                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                </path>
                                            </svg>)
                                            : (
                                                t('Confirm')
                                            )
                                        }

                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }

        </div>
    )
}

export default ReviemParametres